/**
 * Presentation creation and employee packet creation, set in Raleway.
 *
 * Each app's root route renders this around its pages, so the face reaches every page, dialog and
 * menu in the app and nothing outside it: the shell, and the other applications, keep the web
 * face. The deck and packet previews are documents of their own and embed Raleway themselves.
 */
import { useMemo } from 'react';
import { Box } from '@mui/material';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';

import { FONT_DOCUMENT, documentFaceTheme, lineHeight } from '@/theme/theme';

export function DocumentFaceScope(): JSX.Element {
  const outer = useTheme();
  // Built once per colour scheme, not on every render: a new theme restyles everything under it.
  const theme = useMemo(() => documentFaceTheme(outer), [outer]);
  return (
    <ThemeProvider theme={theme}>
      <Box
        data-face="document"
        sx={{ fontFamily: FONT_DOCUMENT, fontFeatureSettings: '"lnum" 1', lineHeight: lineHeight.normal }}
      >
        <Outlet />
      </Box>
    </ThemeProvider>
  );
}
